"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var s = _interopRequireWildcard(require("./styles"));

var _IconRaiseHand = _interopRequireDefault(require("../../../../Icons/IconRaiseHand"));

var _IconLowAttention = _interopRequireDefault(require("../../../../Icons/IconLowAttention"));

var _IconMessageFilled = _interopRequireDefault(require("../../../../Icons/IconMessageFilled"));

/* eslint-disable react/no-unused-prop-types */
function UserLiveClassStatus(props) {
  var chat = props.chat,
      hasLowAttention = props.hasLowAttention,
      isRaisingHand = props.isRaisingHand,
      statusIconClass = props.statusIconClass,
      className = props.className;
  return React.createElement("div", {
    className: (0, _classnames.default)(s.statusContainer, className)
  }, React.createElement(_IconRaiseHand.default, {
    className: (0, _classnames.default)(statusIconClass, s.statusIcon),
    style: {
      color: isRaisingHand ? _themeConfig.default.color.dark.emerald : ''
    }
  }), React.createElement(_IconLowAttention.default, {
    className: (0, _classnames.default)(statusIconClass, s.statusIcon),
    style: {
      color: hasLowAttention ? _themeConfig.default.color.dark.ruby : ''
    }
  }), React.createElement(_IconMessageFilled.default, {
    className: (0, _classnames.default)(statusIconClass, s.statusIcon),
    style: {
      color: chat ? _themeConfig.default.color.dark.amethyst : ''
    }
  }));
}

UserLiveClassStatus.defaultProps = {
  chat: false,
  hasLowAttention: false,
  isRaisingHand: false,
  statusIconClass: null,
  className: null
};
UserLiveClassStatus.propTypes = {
  chat: _propTypes.default.bool,
  hasLowAttention: _propTypes.default.bool,
  isRaisingHand: _propTypes.default.bool,
  statusIconClass: _propTypes.default.object,
  className: _propTypes.default.object
};
var _default = UserLiveClassStatus;
exports.default = _default;